
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion"
import { useEffect, useState } from "react";
import makeMessage from "./MakeMessage";
import url from "./ServerUrl";
import Helmet from "react-helmet";

function Login(){

    // user defined email and password states
    const [inputEmail,setInputEmail] = useState("") 
    const [inputPassword,setInputPassword] = useState("")

    const redirect = useNavigate()

    useEffect(()=>{
        if(localStorage.token){
            redirect("/dashboard")
        }
    },[])

    // when user clicks on Login Button
    const loginUser = async() => {
        
        // input validation 
        if(inputEmail === "" && inputPassword !== ""){
            makeMessage("fa-solid fa-circle-xmark","#ff0000","Please enter your email","#ff0000","temp_1x")
            setTimeout(() => {
                document.getElementById("temp_1x").remove()
            }, 3000);
            return
            
        }
        if(inputEmail !== "" && inputPassword === ""){
            makeMessage("fa-solid fa-circle-xmark","#ff0000","Please enter your password","#ff0000","temp_2x")
            setTimeout(() => {
                document.getElementById("temp_2x").remove()
            }, 3000);
            return
        }
        if(inputEmail === "" && inputPassword === ""){
            makeMessage("fa-solid fa-circle-xmark","#ff0000","Please enter your email and password","#ff0000","temp_3x")
            setTimeout(() => {
                document.getElementById("temp_3x").remove()
            }, 3000);
            return
        }
        let flag = true
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputEmail)) flag = false;


        if(flag){
            makeMessage("fa-solid fa-circle-xmark","#ff0000","Invalid email address","#ff0000","temp_4x")
            setTimeout(() => {
                document.getElementById("temp_4x").remove()
            }, 3000);
            return
        }

        let headersList = {
            "Accept": "*/*",
            "User-Agent": "Thunder Client (https://www.thunderclient.com)",
            "Content-Type": "application/json"
        }
           
        let bodyContent = JSON.stringify({
            "email":inputEmail,
            "passwd":inputPassword
        });
        
        try {
            let response = await fetch(`${url}/login`, { 
                method: "POST",
                body: bodyContent,
                headers: headersList
            });
            if(response.status === 200){
                const output = await response.json()
                localStorage.setItem('token',output.token)
                makeMessage("fa-solid fa-circle-check","	#198754","Login Success!","#198754","temp_6B")
                setTimeout(() => {
                    document.getElementById("temp_6B").remove()
                    window.location.replace("/dashboard")
                }, 3000);
                return
            }

            makeMessage("fa-solid fa-circle-xmark","#ff0000","Incorrect email or password!","#ff0000","temp_1A")
            setTimeout(() => {
                document.getElementById("temp_1A").remove()
            }, 3000);

        } catch (error) {
            makeMessage("fa-solid fa-circle-xmark","#ff0000","Something went wrong!","#ff0000","temp_1A")
            setTimeout(() => {
                document.getElementById("temp_1A").remove()
            }, 3000);
            return
        }
        
    }


    return(
        <>
        <Helmet>
      <title>AstraRescue | Ambulance / EMS Management</title>
            <meta
      name="description"
      content="AstraRescue Ambulance and EMS Management"
    />
        </Helmet>
        <main className="rescue-login-page">
            <section className="rescue-login-visual">
                <div className="rescue-brand-mark" aria-hidden="true">🚑</div>
                <p className="rescue-eyebrow">ASTRA EMERGENCY NETWORK</p>
                <h1>AstraRescue</h1>
                <p className="rescue-tagline">Fast, coordinated ambulance and emergency response management.</p>
                <div className="rescue-benefits">
                    <span>✓ Live request coordination</span>
                    <span>✓ Driver and ambulance operations</span>
                    <span>✓ Secure local access</span>
                </div>
            </section>
            <section className="rescue-login-card" aria-label="AstraRescue login">
                <div className="rescue-card-symbol" aria-hidden="true">✦</div>
                <p className="rescue-eyebrow">WELCOME BACK</p>
                <h2>Sign in to AstraRescue</h2>
                <p className="rescue-card-copy">Access your emergency operations workspace.</p>
                <label htmlFor="rescue-email">Email address</label>
                <div className="rescue-input-wrap"><span aria-hidden="true">@</span><input id="rescue-email" type="email" placeholder="you@example.com" autoComplete="username" onChange={(e)=>setInputEmail(e.target.value)} /></div>
                <label htmlFor="rescue-password">Password</label>
                <div className="rescue-input-wrap"><span aria-hidden="true">●</span><input id="rescue-password" type="password" placeholder="Enter your password" autoComplete="current-password" onChange={(e)=>setInputPassword(e.target.value)} /></div>
                <motion.button className="rescue-login-button" whileTap={{scale: 0.98}} onClick={loginUser}>Sign in <span aria-hidden="true">→</span></motion.button>
                <Link className="rescue-signup-link" to="/signup">Create a new account</Link>
            </section>
        </main>
        </>
    )
}

export default Login;
